"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.documentSignerTheme = void 0;

var _core = require("@material-ui/core");

var _palette = _interopRequireDefault(require("./palette"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var documentSignerTheme = (0, _core.createMuiTheme)({
  palette: _palette.default,
  overrides: {
    MuiTypography: {
      body1: {
        fontSize: '1rem'
      }
    },
    MuiButton: {
      root: {
        fontSize: '1rem',
        textTransform: 'capitalize'
      }
    }
  }
});
exports.documentSignerTheme = documentSignerTheme;